import React, { Component } from 'react';
import { FaUserCircle } from 'react-icons/fa';
import { login } from '../service/authService';
import { find } from 'lodash';
import { toast } from 'react-toastify';
// import logo from '../logo-estep.png';
// import bcrypt from 'bcryptjs';

class Login extends Component {
   state = {
      username: '',
      current_password: '',
      hashPass: '$2a$10$hVnvkHmN6aPugHHbC26S8.W9HnPQbhQunRftBGJy1ZWRwbbJ2fMyW',
      hashPassAdmin: '$2a$10$mJkE4OWRr2HIMTduw6372eMVjQs.PAzjB1osXbn6zaSQ0.VEA6JFm',
      errors: {},
   };
   // hashPass= evspass;
   // hashAdmin = admin!@#123

   handleLogin = async (e) => {
      e.preventDefault();
      const { username, current_password } = this.state;
      try {
         let response = await login(username, current_password);
         const user = await response.data.data;
         const roles = user.roles;
         localStorage.setItem('username', JSON.stringify(user.username));
         localStorage.setItem('user', JSON.stringify(user));
         localStorage.setItem('roles', JSON.stringify(roles));
         console.log(find(roles, { roleId: 1 }));
         if (roles.length > 0) {
            if (find(roles, { roleId: 1 })) {
               window.location = '/DashBoard';
            } else if (find(roles, { roleId: 3 })) {
               window.location = '/RequestHistory';
            } else if (find(roles, { roleId: 4 })) {
               window.location = '/EndDayHistory';
            }
         } else {
            toast.error('user has not given any role', { autoClose: 2000 });
         }
      } catch (error) {
         if (error.response) {
            const errorMessage = error.response.data.errors;
            toast.error(errorMessage, { autoClose: 2000 });
         } else if (error.request) {
            console.log(error.request);
         } else {
            // Something happened in setting up the request and triggered an Error
            const errorMessage = error.message;
            toast.error(errorMessage, { autoClose: 2000 });
         }
      }
   };

   handleChange = (e) => {
      let name = e.target.name;
      this.setState({ [name]: e.target.value });
   };

   render() {
      return (
         <div className='container'>
            <div className='row mt-5 justify-content-center'>
               <div className='col-xs-6 col-md-4'>
                  <div className='card'>
                     <div className='card-body'>
                        <form onSubmit={this.handleLogin}>
                           <div className='text-center'>
                              <h2>
                                 <FaUserCircle />
                              </h2>
                              {/* <img src={logo} className='logo-login' alt={'Logo'} /> */}
                           </div>
                           <hr />
                           <p className='h4 text-center mb-4'>Sign in </p>
                           <div className='form-group'>
                              <label>Username</label>
                              <input
                                 type='text'
                                 className='form-control custom-input'
                                 name='username'
                                 value={this.state.username}
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className='form-group'>
                              <label>Password</label>
                              <input
                                 type='password'
                                 className='form-control custom-input'
                                 name='current_password'
                                 value={this.state.current_password}
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className='form-row'>
                              <div col='col-md-5'>
                                 <button className='btn btn-block btn-custom-blue'>Login</button>
                              </div>
                              <div col='col-md-5'>
                                 <button className='btn btn-link' style={{ fontSize: '13px' }}>
                                    Forgot your password
                                 </button>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

export default Login;
